// @ constants
const actionTypes = require('constants/actionTypes');
const { PERSONETICS } = require('constants/index');
// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;
const apiURLBuilder = require("core/apiURLBuilder");

// @ constants
const {
    CTX_ID,
    EVENT_TYPE_PRESENTED_VALUE,
    EVENT_TYPE_PRESENTED,
    GET_INSIGHTS_CTX_ID,
    GET_INSIGHTS,
    INIT_PERSONETICS,
    PROTOCOL_VERSION,
    SEND_EVENT,
} = require('constants/personetics');

const getPersoneticsInsightsRequest = () => ({
    type: actionTypes.GET_PERSONETICS_INSIGHTS_REQUEST
});

const getPersoneticsInsightsSuccess = (response) => ({
    type: actionTypes.GET_PERSONETICS_INSIGHTS_SUCCESS,
    payload: {
        response
    }
});

const getPersoneticsInsightsFailure = (error) => ({
    type: actionTypes.GET_PERSONETICS_INSIGHTS_FAILURE,
    payload: {
        error
    }
});

const initPersoneticsFailure = (error) => ({
    type: actionTypes.INIT_PERSONETICS_FAILURE,
    payload: {
        error
    }
})

const initPersoneticsSuccess = () => ({
    type: actionTypes.INIT_PERSONETICS_SUCCESS,
})

const setInsightCloseStatus = id => dispatch => {
    dispatch({
        type: actionTypes.SET_PERSONETICS_INSIGHT_CLOSE_STATUS,
        payload: {
            id
        }
    });
};

const updatePersoneticsStatus = () => (dispatch, getState) => {
    const immInsights = getState().personeticsTeaser.get('insights');
    const eventsInfoList = immInsights.map((insight) =>{
        return {
            type: EVENT_TYPE_PRESENTED,
            params: {
                value: EVENT_TYPE_PRESENTED_VALUE,
                insightId: insight.get('insightId'),
                instanceId: insight.get('id')
            }
        }
    });
    const params = {
        query: {
            type: SEND_EVENT,
            protocolVersion: PROTOCOL_VERSION,
            ctxId: CTX_ID,
            lang: getLanguage().toLowerCase(),
            eventsInfoList
        }
    };
    return APIPost({
        dispatch,
        endpoint: 'personeticsIntegrationURL',
        params
    })
}

const getPersoneticsInsights = (accounts,cards) => (dispatch) => {
    dispatch(getPersoneticsInsightsRequest());
    const params = {
        query: {
            type: GET_INSIGHTS,
            protocolVersion: PROTOCOL_VERSION,
            autoGenerate: true,
            ctxId: GET_INSIGHTS_CTX_ID,
            lang: getLanguage().toLowerCase(),
            hints: {
                platform: 'web',
                accounts,
                cards
            }
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'personeticsIntegrationURL',
        params
    })
        .then(response => {
            dispatch(getPersoneticsInsightsSuccess(response));
            if(response.status === '200' && response.statusMessage === 'ok' && response.insights.length > 0){
                dispatch(updatePersoneticsStatus())
            }
        })
        .catch(error => {
            dispatch(getPersoneticsInsightsFailure(error));
        });
};

const initPersonetics = (accounts,cards) => (dispatch) => {
    const params = {
        query: {
            type: INIT_PERSONETICS,
            protocolVersion: PROTOCOL_VERSION
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'personeticsIntegrationURL',
        params
    })
        .then(response => {
            if (response.status === '200' && response.isActive && response.optInStatus === "in") {
                dispatch(getPersoneticsInsights(accounts,cards));
                dispatch(initPersoneticsSuccess());
            } else {
                dispatch(initPersoneticsFailure("error"));
            }
        }).catch(error => {
            dispatch(initPersoneticsFailure(error));
        });
}

const validateVirtualOfficeForPersoneticsRequest = () => ({
    type: actionTypes.VALIDATE_PERSONETICS_VIRTUAL_OFFICES_REQUEST
});

const validateVirtualOfficeForPersoneticsSuccess = response => ({
    type: actionTypes.VALIDATE_PERSONETICS_VIRTUAL_OFFICES_SUCCESS,
    payload: response
});

const validateVirtualOfficeForPersoneticsFailure = () => ({
    type: actionTypes.VALIDATE_PERSONETICS_VIRTUAL_OFFICES_FAILURE
});

const validateVirtualOfficeForPersonetics = (accounts,cards) => (dispatch, getState) => {
    const personeticsVirtualOffices = getState().personeticsVirtualOffices;
    if (!!personeticsVirtualOffices && (personeticsVirtualOffices.get('isFetchingVirtualOffices') || personeticsVirtualOffices.get('virtualOfficeRequestSuccess'))) {
        return Promise.resolve();
    }
    const isPersoneticsEnabled = getState().flagBasedFeatures.get(PERSONETICS);
    const query = {
        header: {
            version: 3
        }
    };
    dispatch(validateVirtualOfficeForPersoneticsRequest());
    return APIGet(dispatch, apiURLBuilder.getURL('validateVirtualOffices', { feature: PERSONETICS }), query)
        .then(response => {
            const isPersoneticsVirtualOfficeeEnabled = response.isFeatureActive;
            dispatch(validateVirtualOfficeForPersoneticsSuccess(response));
            if (isPersoneticsEnabled && isPersoneticsVirtualOfficeeEnabled) {
                dispatch(initPersonetics(accounts,cards));
            }
        })
        .catch(() => {
            dispatch(validateVirtualOfficeForPersoneticsFailure());
        })
}

module.exports = {
    initPersonetics,
    setInsightCloseStatus,
    validateVirtualOfficeForPersonetics
}